module.exports = __webpack_public_path__ + "img/enImg.633c4b2f.png";